const Const = {
    FIXED_FEE_SELECTOR_SET_RETURN_FEE: 'FIXED_FEE_SELECTOR_SET_RETURN_FEE',
    FIXED_FEE_SELECTOR_CLEAR: 'FIXED_FEE_SELECTOR_CLEAR',
};

export default Const;